module.exports = __webpack_public_path__ + "static/media/peopleLogo.b8254bea.svg";